import { isArrayEmpty, Layer, runOnLayersLoaded, selectMany, SoilMapView } from "../../omnia"
import { isLayerVisible } from "./context"

export class AnalysisLayer extends Layer {

    public setView(view: SoilMapView) {

        this.styleProvider = null

        const layers = view.getLayers()

        runOnLayersLoaded(layers, () => {

            let features = this.mergeFeatures(view)

            this._source.clear()
            this._source.addFeatures(features)

            if (!isArrayEmpty(layers)) {
                const inst = layers[0].getMapLayer()
                this.styleProvider = (selected) => inst.getLayerStyleFunction(selected)
            }

            this.refresh()

        })

    }

    getLayerStyleFunction(selected: boolean): (feature, resolution) => any {

        if (this.styleProvider) {
            return this.styleProvider(selected);
        }

        return (feature, resolution) => [];

    }

    private mergeFeatures(view: SoilMapView) {

        if (!view) {
            return [];
        }

        let layers = (view.getLayers() || []).filter(isLayerVisible)

        let features = selectMany(layers.map(l => {

            return l.getMapLayer().getFeatures().map(f => f.clone())

        }))

        return features;

    }

}
